const VALIDATION_TRANSLATIONS = {
  english:    { required: 'Required' },
  irish:      { required: 'Required' },
  portuguese: { required: 'Obrigatório' },
  albanian:   { required: 'E detyrueshme' },
  german:     { required: 'Erforderlich' },
  spanish:    { required: 'Obligatorio' },
  french:     { required: 'Obligatoire' },
  italian:    { required: 'Obbligatorio' },
  dutch:      { required: 'Verplicht' },
  greek:      { required: 'Απαιτείται' },
  turkish:    { required: 'Zorunlu' },
  romanian:   { required: 'Obligatoriu' },
  czech:      { required: 'Povinné' },
  hungarian:  { required: 'Kötelező' },
};

export function getRequiredText(languageName) {
  const lang = (languageName || 'english').toLowerCase();
  return (VALIDATION_TRANSLATIONS[lang] || VALIDATION_TRANSLATIONS.english).required;
}

export default VALIDATION_TRANSLATIONS;
